import { render } from "./Loader.vue?vue&type=template&id=7c05235e"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=7c05235e&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__